import myform from './elform.vue'
import dataTable from './dataTable.vue'
import scrollInfo from './scrollInfo.vue'
import echarts from './echarts.vue'
import hdFilter from './hdFilter.vue'
import hdTabs from './hdTabs.vue'
import upload from './upload.vue'
import checkBox from './checkBox.vue'
// import Tinymce from './Tinymce/index.vue'
const Tinymce = () => import('./Tinymce/index.vue')

export default function install(Vue) {
    Vue.component('myform', myform)
    Vue.component('dataTable', dataTable)
    Vue.component('scrollInfo', scrollInfo)
    Vue.component('echarts', echarts)
    Vue.component('hdFilter', hdFilter)
    Vue.component('hdTabs', hdTabs)
    Vue.component('uploadFile', upload)
    Vue.component('checkBox', checkBox)
    Vue.component('Tinymce',Tinymce)
}